import useProcess from '@hooks/useProcess';
import useStores from '@hooks/useStore';
import { useWorkflow } from '@hooks/useWorkflow';
import PanelHeader from '@panel/PanelHeader';
import { PanelBody } from '@panel/panel.style';
import { observer } from 'mobx-react';
import { Outlet, useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { TRANSITION_TAB_LINKS } from './transition.config';

const Transition = () => {
  const { transitionStore } = useStores();
  const process = useProcess();
  const { workflow } = useWorkflow();

  const transitionId = useParams<string>()[ParamsList.TransitionId] as string;
  const transitionModel = transitionStore.get(transitionId);

  if (!(process && workflow && transitionModel)) {
    return <></>;
  }

  return (
    <>
      <PanelHeader
        actionType="transition"
        infos={[transitionModel.sourceName, transitionModel.targetName]}
        tabLinks={TRANSITION_TAB_LINKS}
        workflowName={workflow.name}
      />
      <PanelBody>
        <Outlet />
      </PanelBody>
    </>
  );
};

export default observer(Transition);
